import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class PrismService {
  constructor(private readonly http: HttpClient) { }

  getCuratedInsightsList(qParam: string) {
    return this.http.get(`insights/insights/?${qParam}`);
  }
  getMLCase() {
    return this.http.get(`insights/ml-case/`);
  }

  uploadCuratedInsightDocument(formData: any) {
    return this.http.post("insights/documents/", formData);
  }
  saveCuratedInsights(data: any) {
    return this.http.post("insights/insights/", data);
  }
  editCuratedInsights(data: any, id: any) {
    return this.http.patch(`insights/insights/${id}/`, data);
  }
  deleteInsight(id: any) {
    return this.http.delete(`insights/insights/${id}/`);
  }
  downloadInsightFile(id: any) {
    return this.http.get(`insights/documents/${id}`, { responseType: "blob" });
  }
  getInsightDocument(docName: any, insightId: any) {
    return this.http.get(
      `insights/documents/download_document/?document=${docName}&insight_id=${insightId}`,
      { responseType: "blob" }
    );
  }
  requestInsight(payload: any) {
    return this.http.post("insights/insights/trigger_email/", payload);
  }
  deleteInsightFile(id: any) {
    return this.http.delete(`insights/documents/${id}`);
  }
  getUser() {
    return this.http.get(`users/user-list/`);
  }

  getAllUsers() {
    return this.http.get(`users/`);
  }

  getSoWMasterList(offSet?: any, end?: any) {
    const params = `offset=${offSet}&end=${end}`;
    return this.http.get(`master/contracts/?${params}`);
  }
  getAllContractList() {
    return this.http.get(`master/contracts/`);
  }

  getContractFiles(queryParams: string) {
    return this.http.get(`master/contracts/files/?contracts=${queryParams}`);
  }

  deleteSoWContract(id: any) {
    return this.http.delete(`master/contracts/${id}`);
  }

  getVendor() {
    return this.http.get(`vendors/names/`);
  }

  saveSowMaster(payload: any) {
    return this.http.post(`master/contracts/`, payload);
  }
  patchSowMaster(payload: any, id: any) {
    return this.http.patch(`master/contracts/${id}/`, payload);
  }
  downloadContractMasterFile(id: any) {
    return this.http.get(`master/contracts/document/${id}`, {
      responseType: "blob",
    });
  }

  getApplicationMasterTree(queryParams: any) {
    return this.http.get(`master/application/tree-view/${queryParams}`);
  }

  getApplicationMaster(offSet?: any, end?: any, vulnerable?: boolean) {
    let url = `master/application`;
    const params: string[] = [];
    if (offSet !== undefined && end !== undefined) {
      params.push(`offset=${offSet}`, `end=${end}`);
    }
    if (vulnerable) {
      params.push(`vulnerable=true`);
    }
    if (params.length) {
      url += `?${params.join("&")}`;
    }
    return this.http.get(url);
  }

  getApplicationNames(query_param: string = "") {
    return this.http.get("master/application/names/" + query_param);
  }

  getApplicationById(id: any) {
    return this.http.get(`master/application/${id}`);
  }
  updateApplication(formValues: any, id: any) {
    return this.http.patch(`master/application/${id}/`, formValues);
  }

  addApplication(formValues: any) {
    return this.http.post(`master/application/`, formValues);
  }

  deleteApplication(id: any) {
    return this.http.delete(`master/application/${id}/`);
  }

  getFilteredApplicationMaster(qParam: string) {
    return this.http.get(`master/application?${qParam}`);
  }

  // Service Master APIs
  getServiceMaster(offSet?: any, end?: any, vulnerable?: boolean) {
    let params = `offset=${offSet}&end=${end}`;
    if (vulnerable) {
      params += `&vulnerable=true`;
    }
    return this.http.get(`master/services/?${params}`);
  }
  getServiceById(id: any) {
    return this.http.get(`master/services/${id}/`);
  }
  addService(formValues: any) {
    return this.http.post(`master/services/`, formValues);
  }
  updateService(formValues: any, id: any) {
    return this.http.patch(`master/services/${id}/`, formValues);
  }
  deleteService(id: any) {
    return this.http.delete(`master/services/${id}/`);
  }
  getFilteredServiceMaster(qParam: string) {
    return this.http.get(`master/services/?${qParam}`);
  }

  getInfrastructureMaster(offSet?: number, end?: number, provider?: number) {
    let url = `master/infrastructures/`;
    const params: string[] = [];
    if (offSet !== undefined && end !== undefined) {
      params.push(`offset=${offSet}`, `end=${end}`);
    }
    if (provider !== undefined) {
      params.push(`provider=${provider}`);
    }
    if (params.length) {
      url += `?${params.join("&")}`;
    }
    return this.http.get(url);
  }

  getInfrastructureNames() {
    return this.http.get("master/infrastructures/names/");
  }

  getInfrastructureById(id: any) {
    return this.http.get(`master/infrastructures/${id}/`);
  }
  addInfrastructure(formValues: any) {
    return this.http.post(`master/infrastructures/`, formValues);
  }
  updateInfrastructure(formValues: any, id: any) {
    return this.http.patch(`master/infrastructures/${id}/`, formValues);
  }
  deleteInfrastructure(id: any) {
    return this.http.delete(`master/infrastructures/${id}/`);
  }
  getFilteredInfrastructureMaster(qParam: string) {
    return this.http.get(`master/infrastructures/?${qParam}`);
  }
  getInfrastuctureProviders() {
    return this.http.get('master/infrastructures/providers')
  }
  getThreatProviders() {
    return this.http.get('grc/incident/providers/')
  }
  getInfrastructureTypes(providerId: any) {
    return this.http.get(`master/infrastructures/types?provider=${providerId}`)
  }
  getInfrastructureCategories() {
    return this.http.get(`master/infrastructures/infrastructure-categories`)
  }
  getInfrastructureSubcategories() {
    return this.http.get(`master/infrastructures/infrastructure-subcategories`)
  }


  discoverInfrastructure(provider: string) {
    return this.http.post(`master/infrastructures/discover/?provider=${provider}`, {})
  }

  scanInfrastructure(provider: string, file?: string) {
    const payload = file ? { file } : {};
    return this.http.post(`master/infrastructures/scan/?provider=${provider}`, payload);
  }

  getInfrastructureScanStatus(providerId: any, type: any) {
    return this.http.get(`master/infrastructures/status?provider=${providerId}&type=${type}`)
  }

  getPackageFilesList() {
    return this.http.get(`master/infrastructures/list-files`)
  }

  getCompetencyList(offSet?: any, end?: any, queryparam?: any) {
    const params = `offset=${offSet}&end=${end}`;
    return this.http.get(
      `metrics/people-competency-map/?${params}${queryparam}`
    );
  }

  getCostPool(offSet?: any, end?: any, queryparam?: any) {
    const params = `offset=${offSet}&end=${end}`;
    return this.http.get(`metrics/cost-pool-taxonomy/?${params}${queryparam}`);
  }
  getItTower(offSet?: any, end?: any, queryparam?: any) {
    const params = `offset=${offSet}&end=${end}`;
    return this.http.get(`metrics/it-tower-taxonomy/?${params}${queryparam}`);
  }
  getServiceTaxonomy(offSet?: any, end?: any, queryparam?: any) {
    const params = `offset=${offSet}&end=${end}`;
    return this.http.get(`metrics/service-taxonomy/?${params}${queryparam}`);
  }
  getSolutionTaxonomy(offSet?: any, end?: any, queryparam?: any) {
    const params = `offset=${offSet}&end=${end}`;
    return this.http.get(`metrics/solution-taxonomy/?${params}${queryparam}`);
  }

  getTypesList() {
    return this.http.get("base_value/?type=contract_type");
  }

  getExecutionTypesList() {
    return this.http.get("base_value/?type=contract_execution_type");
  }

  getStatus() {
    return this.http.get("base_value/?type=contract_status");
  }

  getRiskTypeForCompliance() {
    return this.http.get("base_value/?type=compliance_risk_class");
  }

  getDaysToExpiry() {
    return this.http.get("base_value/?type=days_to_expiry");
  }

  getFilteredSowMasterList(qParam: string) {
    return this.http.get(`master/contracts/?${qParam}`);
  }

  getApplicationTypes() {
    return this.http.get("base_value/?type=application_type");
  }

  getTechMapStatus() {
    return this.http.get("base_value/?type=tech_map_status");
  }

  getMasterhierarchy() {
    return this.http.get("org/portfolios/");
  }
  createPortfolio(payload: any) {
    return this.http.post("org/portfolios/", payload);
  }
  createSubPortfolio(portfolioId: any, payload: any) {
    return this.http.post(
      `org/portfolios/${portfolioId}/create-subportfolio/`,
      payload
    );
  }
  getBaseValue(param: any) {
    return this.http.get(`base_value/?type=${param}`);
  }
  updatePortfolio(portfolioId: any, payload: any) {
    return this.http.patch(`org/portfolios/${portfolioId}/`, payload);
  }
  getInsightCategory() {
    return this.http.get("base_value/?type=maven_category");
  }
  getTag() {
    return this.http.get(`tag`);
  }

  getOrgName() {
    return this.http.get("display-names");
  }

  getTilesNameList() {
    return this.http.get("insights/insights/titles/");
  }

  getInfraServiceTree(applicationId: any) {
    return this.http.get(
      `master/application/tree-view/?search=id:${applicationId}`
    );
  }

  processContract(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post(
      "master/contracts/extract-contract-details/",
      formData
    );
  }

  createProgram(subPortfolioId: any, payload: any) {
    return this.http.post(
      `org/portfolios/${subPortfolioId}/create-program/`,
      payload
    );
  }

  updateProgram(programId: number, payload: any) {
    return this.http.put(`org/programs/${programId}/`, payload);
  }
}
